/* ==========================================================================
   "Build your garage" row.

   Arrows scroll the track, each card's size dropdown updates its price, and
   Add to cart goes through the Ajax cart then opens the theme's cart drawer.
   Prices come pre-formatted from Liquid on each <option>, so there is no
   currency formatting to get wrong here.
   ========================================================================== */
(function () {
  /* ------------------------------------------------------------------------
     Size dropdown

     A native <select>'s open list can't be styled — it always draws the
     browser's default menu. So the select is hidden (it still submits the
     form, and is what's left if this script never runs) and a button +
     listbox stands in for it, writing every choice back to the select and
     firing its change event so the price logic stays in one place.

     The list opens UPWARD over the card's photo: the card and the scrolling
     track both clip overflow, so a list dropping below the card would be cut.
     ------------------------------------------------------------------------ */
  var openDropdown = null;

  function closeOpen(focusButton) {
    if (!openDropdown) return;
    var dd = openDropdown;
    openDropdown = null;
    dd.list.hidden = true;
    dd.button.setAttribute('aria-expanded', 'false');
    dd.wrap.classList.remove('is-open');
    if (focusButton) dd.button.focus();
  }

  document.addEventListener('click', function (e) {
    if (openDropdown && !openDropdown.wrap.contains(e.target)) closeOpen(false);
  });

  var ddCount = 0;
  function enhanceSelect(select) {
    ddCount += 1;
    var listId = 'fb-sq-dd-' + ddCount;

    var wrap = document.createElement('div');
    wrap.className = 'fb-sq-dd';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fb-sq-dd-btn';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', listId);
    if (select.getAttribute('aria-label')) button.setAttribute('aria-label', select.getAttribute('aria-label') + ': ' + select.options[select.selectedIndex].text);
    var buttonText = document.createElement('span');
    buttonText.className = 'fb-sq-dd-value';
    button.appendChild(buttonText);
    button.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>');

    var list = document.createElement('ul');
    list.className = 'fb-sq-dd-list';
    list.id = listId;
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    list.hidden = true;

    var items = Array.prototype.map.call(select.options, function (opt, i) {
      var li = document.createElement('li');
      li.className = 'fb-sq-dd-opt';
      li.setAttribute('role', 'option');
      li.id = listId + '-' + i;
      var label = document.createElement('span');
      label.textContent = opt.text;
      var price = document.createElement('span');
      price.className = 'fb-sq-dd-price';
      price.textContent = opt.disabled ? 'Sold out' : opt.getAttribute('data-price');
      li.appendChild(label);
      li.appendChild(price);
      if (opt.disabled) li.setAttribute('aria-disabled', 'true');
      li.addEventListener('click', function () { choose(i); });
      li.addEventListener('mousemove', function () { highlight(i); });
      list.appendChild(li);
      return li;
    });

    var dd = { wrap: wrap, button: button, list: list };
    var active = select.selectedIndex;

    function render() {
      var opt = select.options[select.selectedIndex];
      buttonText.textContent = opt ? opt.text : '';
      if (opt && select.getAttribute('aria-label')) button.setAttribute('aria-label', select.getAttribute('aria-label') + ': ' + opt.text);
      items.forEach(function (li, i) { li.setAttribute('aria-selected', i === select.selectedIndex ? 'true' : 'false'); });
    }

    function highlight(i) {
      active = i;
      items.forEach(function (li, j) { li.classList.toggle('is-active', j === i); });
      list.setAttribute('aria-activedescendant', items[i].id);
      var li = items[i];
      if (li.offsetTop < list.scrollTop) list.scrollTop = li.offsetTop;
      else if (li.offsetTop + li.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = li.offsetTop + li.offsetHeight - list.clientHeight;
    }

    function move(from, dir) {
      for (var i = from + dir; i >= 0 && i < items.length; i += dir) {
        if (!select.options[i].disabled) return i;
      }
      return from;
    }

    function open() {
      if (openDropdown && openDropdown !== dd) closeOpen(false);
      openDropdown = dd;
      list.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      highlight(select.selectedIndex);
      list.focus();
    }

    function choose(i) {
      if (select.options[i].disabled) return;
      if (select.selectedIndex !== i) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      render();
      closeOpen(true);
    }

    button.addEventListener('click', function () {
      if (openDropdown === dd) closeOpen(false); else open();
    });
    button.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    list.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(move(active, 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(move(active, -1)); }
      else if (e.key === 'Home') { e.preventDefault(); highlight(move(-1, 1)); }
      else if (e.key === 'End') { e.preventDefault(); highlight(move(items.length, -1)); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(active); }
      else if (e.key === 'Escape') { e.preventDefault(); closeOpen(true); }
      else if (e.key === 'Tab') { closeOpen(false); }
    });

    wrap.appendChild(button);
    wrap.appendChild(list);
    select.classList.add('is-enhanced');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    select.parentNode.insertBefore(wrap, select);
    render();
  }

  document.querySelectorAll('[data-fb-garage]').forEach(function (root) {
    if (root.dataset.fbReady) return;
    root.dataset.fbReady = '1';

    /* ---------------- Arrows ---------------- */
    var track = root.querySelector('[data-fb-sq-track]');
    var prev = root.querySelector('[data-fb-sq-prev]');
    var next = root.querySelector('[data-fb-sq-next]');

    var updateArrows = function () {
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      // Nothing to scroll: hide the arrows rather than show two dead buttons.
      var arrows = root.querySelector('.fb-sq-arrows');
      if (arrows) arrows.style.visibility = max <= 2 ? 'hidden' : '';
    };

    var step = function (dir) {
      var card = track.querySelector('.fb-sq-card');
      var amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };

    if (track) {
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    /* ---------------- Size → price ---------------- */
    root.querySelectorAll('[data-fb-sq-select]').forEach(function (select) {
      var card = select.closest('.fb-sq-card');
      var priceEl = card.querySelector('[data-fb-sq-price]');
      var compareEl = card.querySelector('[data-fb-sq-compare]');
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        if (priceEl) priceEl.textContent = opt.getAttribute('data-price');
        if (compareEl) {
          var compare = opt.getAttribute('data-compare');
          compareEl.textContent = compare;
          compareEl.hidden = !compare;
        }
      });
      enhanceSelect(select);
    });

    /* ---------------- Ajax add to cart ---------------- */
    var addUrl = root.getAttribute('data-cart-add-url');
    var addedLabel = root.getAttribute('data-added-label') || 'Added ✓';
    if (!addUrl || !window.fetch) return;

    root.querySelectorAll('[data-fb-sq-form]').forEach(function (form) {
      var btn = form.querySelector('[data-fb-sq-add]');
      var idInput = form.querySelector('[name="id"]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!btn || !idInput || btn.disabled) return;
        var original = btn.textContent;
        btn.disabled = true;
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: idInput.value, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw d; }); return r.json(); })
          .then(function () {
            btn.textContent = addedLabel;
            btn.classList.add('is-added');
            // Same order as the buy box: open first, then refresh, so the
            // drawer never mounts against stale contents.
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          })
          .catch(function (err) {
            btn.textContent = (err && err.description) || 'Could not add';
          })
          .then(function () {
            setTimeout(function () {
              btn.textContent = original;
              btn.classList.remove('is-added');
              btn.disabled = false;
            }, 1800);
          });
      });
    });
  });
})();
